import { Button } from "@chakra-ui/react";
import { BeatLoader } from "react-spinners";

interface MainButtonProps {
  colorButton?: string;
  fontSizeButton?: string;
  backgroundColorButton?: string;
  title: string;
  onClick?: () => void;
  isLoading?: boolean;
  width?: string;
  style?: any;
  margim?: any;
}

export const MainButton = ({
  title,
  fontSizeButton = "17px",
  colorButton = "#FFFF",
  backgroundColorButton = "#009D57",
  onClick,
  isLoading = false,
  width = "auto",
  style = {},
  margim = "0px 40px 20px 40px"
}: MainButtonProps) => {
  return (
    <Button
      isLoading={isLoading}
      spinner={<BeatLoader size={8} color={backgroundColorButton} />}
      backgroundColor={backgroundColorButton}
      color={colorButton}
      fontSize={fontSizeButton}
      fontWeight="bold"
      margin={margim}
      minHeight="50px"
      borderRadius="10px"
      width={width}
      onClick={onClick}
      style={style}
      _loading={{opacity: 1.0,bg: "gray.200"}}
    >
      {title}
    </Button>
  );
};

/*
<Button
      
          width="292px"
          height="45px"
          marginY="60px"
          padding="12px 65px"
         
          
        >
          enviar cadastro
        </Button>
*/
